module.exports = __webpack_public_path__ + "img/gambling_therapy.3839c1bb.svg";